"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _CharacteristicsFilters = _interopRequireDefault(require("../../components/CampaignCreator/CharacteristicsFilters"));

var _EnquireModal = _interopRequireDefault(require("../../components/CampaignCreator/EnquireModal"));

var _contact = require("../../actions/contact");

var _industryData = require("../../actions/data/industryData");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// TODO: Move this into Containers folder
var PlaceholderMetrics = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PlaceholderMetrics, _React$Component);

  function PlaceholderMetrics(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "openModal", function (industryOfInterest) {
      _this.setState({
        open: true,
        industryOfInterest: industryOfInterest
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        open: false
      });

      _this.props.premiumDataEnquiryReset();
    });

    _this.props.loadIndustryData();

    _this.state = {
      open: false,
      closeOnEscape: false,
      closeOnDimmerClick: false,
      industryOfInterest: ''
    };
    return _this;
  }

  var _proto = PlaceholderMetrics.prototype;

  _proto.render = function render() {
    var _this$state = this.state,
        open = _this$state.open,
        closeOnEscape = _this$state.closeOnEscape,
        closeOnDimmerClick = _this$state.closeOnDimmerClick;
    var industryData = this.props.industryData;
    return /*#__PURE__*/React.createElement("div", {
      className: "grouped-personas__industry-data-wrapper"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "grouped-personas__sub-title"
    }, "Industry Data"), industryData && industryData.categories && /*#__PURE__*/React.createElement(_CharacteristicsFilters["default"], {
      className: "scroll-box",
      characteristics: industryData,
      hasAccess: false,
      noAccessAction: this.openModal
    }), /*#__PURE__*/React.createElement(_EnquireModal["default"], {
      closeOnEscape: closeOnEscape,
      closeOnDimmerClick: closeOnDimmerClick,
      open: open,
      closeModal: this.closeModal,
      industryOfInterest: this.state.industryOfInterest
    }));
  };

  return PlaceholderMetrics;
}(React.Component); // get something out of global store


var mapStateToProps = function mapStateToProps(state, props) {
  return {
    enquiryError: state.contact.error,
    enquirySent: state.contact.fetched,
    isFetching: state.contact.isFetching,
    industryData: state.dataPages.industryData
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    premiumDataEnquiry: _contact.premiumDataEnquiry,
    premiumDataEnquiryReset: _contact.premiumDataEnquiryReset,
    loadIndustryData: _industryData.loadIndustryData
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PlaceholderMetrics);

exports["default"] = _default;